'use strict';

//Includes
import { AppContext } from 'plugin/liferay-widgets-react-web';
import { getSubscriptionStore } from './stores/StoreFactory';

// Actions
export { default as SubscriptionActions } from './actions/SubscriptionActions';

//WebApi
import { default as SubscriptionWebApi } from './webapi/SubscriptionWebApi';
export { SubscriptionWebApi };

//Stores
export * from './stores/StoreFactory';
getSubscriptionStore(AppContext); //Load Store by default

//Components
export { default as UserMultiSubscriptionButton } from './components/UserMultiSubscriptionButton';

//Widgets
export { default as UserSubscriptions } from './widgets/UserSubscriptions';

//Other
AppContext.registerBundle({
    webApis: {
        SubscriptionWebApi
    }
});

export const Subscription = undefined;



// WEBPACK FOOTER //
// ./js/pub-sub-portlet.js